// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-text-section {
  width: 100%;
  background-color: #c5c8ce; /* Gri exact ca în imagine */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  box-sizing: border-box;
}

.scroll-text-container {
  text-align: center;
  line-height: 1.1;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: -2px; /* Mai apropiat de design */
}

.scroll-line {
  margin: 0;
  font-size: clamp(2rem, 8vw, 6rem);
}

.scroll-line.black {
  color: #1a1a1a; /* Negru text */
}

.scroll-line.white {
  color: #ffffff; /* Alb text */
}

.scroll-line-divider {
  width: 100%;
  max-width: 98%;
  border-bottom: 1px solid #1a1a1a;
  margin-top: 20px;
}

/* Responsive */
@media (max-width: 768px) {
  .scroll-text-section {
    padding: 50px 15px;
  }

  .scroll-line {
    font-size: clamp(1.8rem, 10vw, 4rem);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ScrollTextSection.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB,EAAE,4BAA4B;EACvD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB,EAAE,2BAA2B;AACnD;;AAEA;EACE,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,cAAc,EAAE,eAAe;AACjC;;AAEA;EACE,cAAc,EAAE,aAAa;AAC/B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,oCAAoC;EACtC;AACF","sourcesContent":[".scroll-text-section {\n  width: 100%;\n  background-color: #c5c8ce; /* Gri exact ca în imagine */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 80px 20px;\n  box-sizing: border-box;\n}\n\n.scroll-text-container {\n  text-align: center;\n  line-height: 1.1;\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: -2px; /* Mai apropiat de design */\n}\n\n.scroll-line {\n  margin: 0;\n  font-size: clamp(2rem, 8vw, 6rem);\n}\n\n.scroll-line.black {\n  color: #1a1a1a; /* Negru text */\n}\n\n.scroll-line.white {\n  color: #ffffff; /* Alb text */\n}\n\n.scroll-line-divider {\n  width: 100%;\n  max-width: 98%;\n  border-bottom: 1px solid #1a1a1a;\n  margin-top: 20px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .scroll-text-section {\n    padding: 50px 15px;\n  }\n\n  .scroll-line {\n    font-size: clamp(1.8rem, 10vw, 4rem);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
